<div class="content-2">
  <h1 class="title-2"  [style.color]="fontColor">
    {{ title }}
    <div class="style-div"></div>
  </h1>
</div>